import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from 'src/shared/error';

export type NewsAndGuidesListPageDataErrorCode = 'news_and_guides_list_page_data_no_guides';
export class NewsAndGuidesListPageDataError extends PageDataError<NewsAndGuidesListPageDataErrorCode> {}
setClassName(NewsAndGuidesListPageDataError, 'NewsAndGuidesListPageDataError');
